module.exports = __webpack_public_path__ + "img/newSign.7c93a7fa.jpg";